import { styled } from '@mui/material'

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Title = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 8px;
`
